module.exports = __webpack_public_path__ + "static/media/banner_6.ee8f73e6.jpg";